import {GROUP_TYPE, CURSOR, getTextColor, GROUP_SECTION_WIDTH, drawRectangle, drawExpansionIcon, drawArrows, COMMON_IMAGE /*, createCacheCanvas*/} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class ProjectSubGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PROJECT_SUB_GROUP, data);
	}

	refreshData(updatedProject) {
		this.data.color = updatedProject.projectColor;
	}

	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, expanded, groupType} = this;
		super.draw(x, y, width, height, this);
		const {name, id, color, phases, groups, count} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;
		const isMilestoneSubGroup = data.id.includes('phases');
		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const textColor = getTextColor(color);

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			canvasContext.fillStyle = textColor;
			canvasContext.fillText(`${name} (${isMilestoneSubGroup ? phases.length : groups ? groups.filter(group => !group.filtered).length : count !== undefined ? count : '-'})`, x + 53, y + 24);
			return;
		}

		/*const drawGroup = icon => {
			const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
			const context = cacheCanvas.getContext('2d');
			const yOffset = data.projectGroupTeam ? 1 : isMilestoneSubGroup ? 0 : -1;
			drawRectangle(context, data.isInProjectGroup ? 16 : 10, yOffset, width - 10 - (data.isInProjectGroup ? 6 : 0), height - yOffset, {
				backgroundColor: color,
				borderColor: '#ffffff',
				borderThickness: 1
			});
			drawExpansionIcon(context, 0, 0, width, height, {
				backgroundColor: color,
				expanded
			});
			context.fillStyle = textColor;
			context.font = '500 10px ' + Util.getFontFamily();
			if (icon) {
				context.drawImage(icon, 25, 12, 14, 14);
			}
			if (isMilestoneSubGroup && phases.filter(phase => phase.startDay && phase.deadlineDay).length) {
				drawArrows(
					context,
					textColor,
					145,
					14,
					cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'GO_TO_PREVIOUS_WHITE' : 'GO_TO_PREVIOUS']),
					cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'GO_TO_NEXT_WHITE' : 'GO_TO_NEXT'])
				);
			}
			cacheManager.set(groupType, cacheId, cacheCanvas);
			canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
		};*/
		const drawGroup = icon => {
			const yOffset = data.projectGroupTeam ? 1 : isMilestoneSubGroup ? 0 : -1;
			drawRectangle(canvasContext, x + (data.isInProjectGroup ? 16 : 10), y + yOffset, width - 10 - (data.isInProjectGroup ? 6 : 0), height - yOffset, {
				backgroundColor: color,
				borderColor: '#ffffff',
				borderThickness: 1,
			});
			if (!data.preventExpansion) {
				drawExpansionIcon(canvasContext, x, y, width, height, {
					backgroundColor: color,
					expanded,
				});
			}

			canvasContext.fillStyle = textColor;
			canvasContext.font = '500 10px ' + Util.getFontFamily();
			if (icon) {
				canvasContext.drawImage(icon, x + 25, y + 12, 14, 14);
			}
			if (isMilestoneSubGroup && phases.filter(phase => phase.startDay && phase.deadlineDay).length) {
				drawArrows(
					canvasContext,
					textColor,
					x + 155,
					y + 14,
					cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'GO_TO_PREVIOUS_WHITE' : 'GO_TO_PREVIOUS']),
					cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'GO_TO_NEXT_WHITE' : 'GO_TO_NEXT'])
				);
			}
		};
		drawGroup(cacheManager.getCommonImage(COMMON_IMAGE[`${isMilestoneSubGroup ? 'MILESTONE_ICON_' : 'PROJECT_TEAM_ICON_'}${textColor === '#ffffff' ? 'WHITE' : 'BLACK'}`]));
		canvasContext.fillStyle = textColor;
		canvasContext.fillText(`${name} (${isMilestoneSubGroup ? phases.length : groups ? groups.filter(group => !group.filtered).length : count !== undefined ? count : '-'})`, x + 53, y + 24);
	}
}

export default ProjectSubGroup;
